<hd-field-label [label]="label" [subLabel]="description" [showRequiredAsterisk]="control.hasValidator(Validators.required)"/>

<div class="flex gap-2 justify-between">
  @for (option of options$$(); track option) {
    <div (click)="control.setValue(option.value)" class="h-[52px] w-[70px] flex flex-col items-center justify-center border border-neutral-80-outline-secondary rounded-xl cursor-pointer hover:bg-surface-container-low"
         [ngClass]="[option.value === control.value ? 'bg-secondary-95-container' : 'bg-white']">
      <div class="text-center py-2 px-4 label-m text-neutral-30-secondary">{{ (translatePrefix + '.' + option.label ) | translate }}</div>
    </div>
  }
</div>

<mat-error hd-field-error [validationErrorMessage]="validationErrorMessage$$()"/>
